var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item-wrapper"},[_c('module-title',{attrs:{"type":"m"}},[_vm._v("项目运营提升百分比")]),_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }